
      export interface IntrospectionResultData {
        __schema: {
          types: {
            kind: string;
            name: string;
            possibleTypes: {
              name: string;
            }[];
          }[];
        };
      }
      const result: IntrospectionResultData = {
  "__schema": {
    "types": [
      {
        "kind": "INTERFACE",
        "name": "Node",
        "possibleTypes": [
          {
            "name": "Query"
          },
          {
            "name": "Bdi2"
          },
          {
            "name": "Case"
          },
          {
            "name": "InterviewBooking"
          },
          {
            "name": "Involvement"
          },
          {
            "name": "User"
          },
          {
            "name": "InterviewOffer"
          },
          {
            "name": "InterviewReport"
          },
          {
            "name": "CaseMessage"
          },
          {
            "name": "DueTask"
          },
          {
            "name": "MyTaskLog"
          },
          {
            "name": "Eurohi"
          },
          {
            "name": "Gad7"
          },
          {
            "name": "Inep"
          },
          {
            "name": "Lsa"
          },
          {
            "name": "Mspss"
          },
          {
            "name": "Pathev"
          },
          {
            "name": "Pcl5"
          },
          {
            "name": "Phq15"
          },
          {
            "name": "Phq9"
          },
          {
            "name": "Pmb"
          },
          {
            "name": "Sewip"
          },
          {
            "name": "Taq"
          },
          {
            "name": "Traumaliste"
          },
          {
            "name": "Trgi"
          },
          {
            "name": "Wai"
          },
          {
            "name": "CbtActivity"
          },
          {
            "name": "CbtReframing"
          },
          {
            "name": "CbtThought"
          },
          {
            "name": "Comment"
          },
          {
            "name": "Demographic"
          },
          {
            "name": "Disclosure"
          },
          {
            "name": "Evaluation"
          },
          {
            "name": "IptConflict"
          },
          {
            "name": "IptRelationship"
          },
          {
            "name": "IptSituation"
          },
          {
            "name": "Lec5"
          },
          {
            "name": "Letter"
          },
          {
            "name": "LoginToken"
          },
          {
            "name": "Pg13"
          },
          {
            "name": "CaseSuicideCall"
          },
          {
            "name": "LetterTemplate"
          },
          {
            "name": "Scaling"
          },
          {
            "name": "Sbqr"
          },
          {
            "name": "Gad2"
          },
          {
            "name": "Cdrisk10"
          },
          {
            "name": "Traumalisteneu"
          },
          {
            "name": "Itq"
          },
          {
            "name": "Tgisrplus"
          },
          {
            "name": "RandomizationTicket"
          },
          {
            "name": "SuicideNote"
          },
          {
            "name": "FeedbackInterviewReport"
          },
          {
            "name": "HashedEmail"
          }
        ]
      }
    ]
  }
};
      export default result;
    